import React from 'react'
import { styled } from 'linaria/react'
import { useIntl } from '@jetshop/intl'

const FooterWrapper = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 1rem;
   padding: 0.75rem 1rem;
   border-top: 1px solid var(--color-separator);
   background-color: var(--color-vb-gray-1);

   .filter-footer-clear {
      background: none;
      border: none;
      padding: 0;
      font-weight: 700;
      text-decoration: underline;
      color: var(--color-vb-blue);
      cursor: pointer;

      &:disabled {
         opacity: 0.5;
         cursor: default;
      }
   }

   /* Two buttons side by side, tighter so both fit in a narrow drawer */
   &.has-clear-button {
      gap: 0.5rem;
   }

   .filter-footer-clear.is-button + .filter-footer-submit {
      flex: 1;
      min-width: 0;
      padding: 10px 12px;
   }

   .filter-footer-clear.is-button {
      flex-shrink: 0;
      padding: 10px 14px;
      background-color: var(--color-white);
      border: 1px solid var(--color-separator);
      border-radius: 999px;
      color: var(--color-black);
      font-family: var(--font-industry);
      text-decoration: none;
      white-space: nowrap;
   }

   .filter-footer-submit {
      white-space: nowrap;
      padding: 10px 18px;
      border: none;
      border-radius: 999px;
      background-color: var(--color-vb-blue);
      color: var(--color-white);
      font-family: var(--font-industry);
      font-weight: 700;
      cursor: pointer;

      &:hover {
         background-color: var(--color-vb-blue-darker);
      }
   }
`

/**
 * Footer with a clear link and a "Show N products" button, shared by filter dropdowns and the mobile filter drawer.
 */
const FilterPanelFooter = ({
   onClear,
   clearDisabled,
   clearLabel,
   clearAsButton = false,
   onSubmit,
   totalCount,
   className,
}) => {
   const t = useIntl()
   return (
      <FooterWrapper
         className={[className, clearAsButton && 'has-clear-button']
            .filter(Boolean)
            .join(' ')}
      >
         <button
            type="button"
            className={`filter-footer-clear${
               clearAsButton ? ' is-button' : ''
            }`}
            onClick={onClear}
            disabled={clearDisabled}
         >
            {clearLabel ?? t('Clear')}
         </button>
         <button
            type="button"
            className="filter-footer-submit"
            onClick={onSubmit}
         >
            {t('Show { count } products', { count: totalCount ?? 0 })}
         </button>
      </FooterWrapper>
   )
}

export default FilterPanelFooter
